import React from "react";
import CustomLink from "./custom-link";

import "../styles/image-card.scss";

const ImageCard = ({ title, imageUrl, content, totalItems, setCategory }) => {

  const navigateToMenu = () => {
   setCategory(content)
  }

  return (
    <div className="image-card" onClick={navigateToMenu}>
      <CustomLink to="/menu">
        <div className="image-container">
          <img src={imageUrl} alt="image" className="image-card__image" />
        </div>
        <div className="card-content">
          <h4 className="card-title">{content}</h4>
          {/* <span>{totalItems} dishes</span> */}
        </div>
      </CustomLink>
    </div>
  );
};

export default ImageCard;
